// Pure helpers for the Fleet Editor's agent/facet navigation (ADR-111 IA-1/IA-2).
// Kept out of FleetEditor.tsx so the component file only exports components
// (react-refresh) and so this logic is unit-testable without mounting the editor.

// `files` (ADR-111 IA-7) is the agent-scoped long tail: everything under
// agents/<agent>/ that no typed facet owns, chiefly the activities/*.py step
// bodies an ADR-080 python task runs. It is listed LAST because the typed editors
// stay primary (IA-2) — this is the escape hatch beside them, not a return to the
// file-centric IA the 2026-07-28 addendum rejected.
export type Facet =
  | 'persona' | 'skills' | 'workflows' | 'crons' | 'capabilities' | 'profile' | 'routing' | 'files'

// The brain convention used across the codebase (see e.g. `spartan-brain`,
// `athena-brain` in mission-control/backend test fixtures) — no dedicated
// "is this the brain" endpoint exists, so this mirrors that naming pattern.
export const isBrain = (agent: string) => agent.endsWith('-brain')

/**
 * railFacetFor picks the facet to open when the operator switches the focused
 * agent via the rail. It PRESERVES the currently-open facet (Persona/Skills/
 * Workflows/Crons/Capabilities/Profile) so a switch doesn't snap back to
 * Workflows. Two fallbacks to `workflows`: no facet is active (e.g. arriving
 * from the Resources view), or the current facet is the brain-only `routing`
 * facet and the target agent is not a brain (routing isn't a valid facet there).
 */
export function railFacetFor(currentFacet: Facet | undefined, targetAgent: string): Facet {
  if (currentFacet && (currentFacet !== 'routing' || isBrain(targetAgent))) {
    return currentFacet
  }
  return 'workflows'
}
